import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import IHttpRequest from "src/http/http-request";
import { rejects } from "assert";
import { resolve } from "path";
import { loadBMap } from "src/utils";

/**
 * 店铺商品服务。
 * @class
 * @version 1.0.0
 */
export default class StoreProductService extends ServiceBase {
  /*
   * 店铺商品服务。
   * @private
   * @return StoreProductService
   */
  private static _instance: StoreProductService;

  /**
   * 店铺商品服务实例
   * @static
   * @property
   * @returns StoreProductService
   */
  public static get instance(): StoreProductService {
    if (!this._instance) {
      this._instance = new StoreProductService();
    }

    return this._instance;
  }

  /**
   * 获取店铺商品
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getStoreProduct(data: any): Promise<IHttpResponse> {
    let response = await this.apis.getStoreProduct({
      data: data,
      loading: false,
    });

    return response;
  }

  /**
   * 获取商品分类
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getStoreProductType(cityName: string): Promise<IHttpResponse> {
    let response = await this.apis.getStoreProductType({ params: { cityName }, loading: false });
    return response;
  }

  /**
   * 获取权益商品列表
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getRightsList(): Promise<IHttpResponse> {
    let response = await this.apis.getRightsList({ loading: false });
    return response;
  }

  /**
   * 获取指定权益商品列表
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getRightsListByPost(data: any): Promise<IHttpResponse> {
    let response = await this.apis.getRightsListByPost({ data, loading: false });
    return response;
  }

  /**
   * 获取权益商品详情
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getRightsDetail(id): Promise<IHttpResponse> {
    let response = await this.apis.getRightsDetail({ params: { id } });
    return response;
  }

  /**
   * 获取权益商品内产品详情
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getRightsProductDetail(id): Promise<IHttpResponse> {
    let response = await this.apis.getRightsProductDetail({ params: { id } });
    return response;
  }

  /**
   * 获取服务商品牌列表
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getStorePackageBrandType(data: any): Promise<IHttpResponse> {
    let response = await this.apis.getStorePackageBrandType({ data });
    return response;
  }

  /**
   * 通过机构拿套餐
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async storeProductPageList(data: any): Promise<IHttpResponse> {
    let response = await this.apis.storeProductPageList({ data, loading: false });
    return response;
  }

  /**
   * 机构列表
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async hospitalPageList(data: any): Promise<IHttpResponse> {
    let response = await this.apis.hospitalPageList({ data, loading: false });
    return response;
  }
}
